import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNeutral = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M96.9642 86.5749L29.9999 79.5367L31.0557 69.4921L98.0199 76.5303L96.9642 86.5749Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 49.2819,
			cy: 49.4166,
			r: 8.41664,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 79.5817,
			cy: 49.4166,
			r: 8.41664,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgNeutral);
export default ForwardRef;
